import { useState } from 'preact/hooks';
import { UserTable } from './user-table';
import { UserDetail } from './user-detail';

export function UsersTab() {
  const [view, setView] = useState<'list' | 'detail'>('list');
  const [selectedUserId, setSelectedUserId] = useState('');

  const openDetail = (id: string) => {
    setSelectedUserId(id);
    setView('detail');
  };

  const backToList = () => {
    setView('list');
  };

  if (view === 'detail') {
    return <UserDetail userId={selectedUserId} onBack={backToList} />;
  }

  return <UserTable onSelect={openDetail} />;
}
